import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ChantUserTextField } from '@core/models/cu/chant-user-model';
import { ImportALlModule } from '@shared/imports';

@Component({
  selector: 'app-input-text-field',
  standalone: true,
  imports: [
    ImportALlModule,
  ],
  templateUrl: './input-text-field.component.html',
  styleUrl: './input-text-field.component.scss'
})
export class InputTextFieldComponent {

  textField = ChantUserTextField;
  @Input() objDataText: any = '';
  @Input() inputType: string = "text";
  @Input() labelText: string = "";
  @Input() placeholderText: string = "";
  @Input() control!: FormControl;
  @Input() controlValidation!: any;
  @Output() ngModelDataChange = new EventEmitter<any>();

  ngModelDataValue: any;

  private _ngModelData: any = '';
  @Input()
  get ngModelData(): any {
    return this._ngModelData;
  }

  set ngModelData(value: any) {
    this._ngModelData = value;
    this.ngModelDataChange.emit(value);
  }

}

